import React, { useEffect, useState } from "react";
import DashboardScheduleList from "./DashboardScheduleList";
import DashboardScheduleLive from "./DashboardScheduleLive";
import axios from "../../api/axios";
import { useSelector } from "react-redux";
import DashboardGraph from "./DashboardGraph";
import DashboardCalendar from "./DashboardCalendar";
import { Puff } from "react-loader-spinner";
import { toBeRequired } from "@testing-library/jest-dom/matchers";

const DashboardDetail = () => {
  const profileData = useSelector((state) => state.profileData.userData);
  const [allSchedules, setAllSchedules] = useState([]);
  const [currentSchedule, setCurrentSchedule] = useState({});
  const [isUpdate, setIsUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getAllBatchSchedules = () => {
    const url = `/batch/all-schedules/${profileData._id}`;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("oeson_auth")}`,
      },
    };
    axios
      .get(url, config)
      .then((res) => {
        const { data } = res.data;
        setAllSchedules(data);
        if (data && data.length > 0) {
          setCurrentSchedule({
            lesson: data[0],
            batch_name: data[0].batch_name,
            meetLink: data[0].meetLink,
            module_title: data[0].module_title,
          });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err?.response?.data?.message || "");
      });
  };

  useEffect(() => {
    if (profileData && Object.keys(profileData).length > 0) {
      getAllBatchSchedules();
    }
  }, [profileData, isUpdate]);

  return (
    <div className="row">
      <div className="col-xl-8 col-lg-8 col-md-8 col-12">
        {isLoading ? (
          <div
            className="dashboard_schedule_container dashboard_schedule_container_loader d-flex justify-content-center align-items-center "
         
          >
            <Puff
              visible={true}
              height="80"
              width="80"
              color="#024c87"
              ariaLabel="puff-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        ) : (
          <>
            <DashboardScheduleLive
              currentSchedule={currentSchedule.lesson}
              meetlink={currentSchedule.meetLink}
              setIsUpdate={setIsUpdate}
            />
            <DashboardScheduleList allSchedules={allSchedules || []} />
          </>
        )}
      </div>
      <div className="col-xl-4 col-lg-4 col-md-4 col-12">
        <DashboardGraph />
        <DashboardCalendar value={[new Date()]} />
      </div>
    </div>
  );
};

export default DashboardDetail;
